export default __webpack_public_path__ + "static/assets/674db5c2e49df884273ac0f7d221865c.svg";